import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  FaReact,
  FaNodeJs,
  FaPython,
  FaDatabase,
  FaGitAlt,
  FaFigma,
  FaHtml5,
  FaCss3,
  FaJava,
  FaAngular,
  FaBrain,
  FaCodeBranch,
  FaAws,
  FaServer,
  FaGithub,
  FaKey,
  FaCubes,
  FaEye,
  FaRoute,
  FaVideo,
  FaLinux,
  FaPlug,
  FaMicrochip,
  FaNetworkWired,
  FaSitemap,
  FaMobileAlt,
  FaLayerGroup,
  FaBox,
  FaBroadcastTower,
  FaMountain,
  FaUserCircle,
  FaGraduationCap,
  FaCheck
} from 'react-icons/fa';
import {
  SiNextdotjs,
  SiVite,
  SiTypescript,
  SiJavascript,
  SiTailwindcss,
  SiExpress,
  SiCplusplus,
  SiMongodb,
  SiPostgresql,
  SiFirebase,
  SiTensorflow,
  SiPytorch,
  SiOpencv,
  SiN8N,
  SiDocker,
  SiKubernetes,
  SiJenkins
} from 'react-icons/si';

const About = ({ aboutRef, skills }) => {
  const skillCategories = [
    {
      title: "Frontend & UI/UX",
      skills: [
        { name: "React", icon: <FaReact />, color: "var(--accent-primary)" },
        { name: "Next.js", icon: <SiNextdotjs />, color: "var(--text-primary)" },
        { name: "Vite", icon: <SiVite />, color: "var(--accent-primary)" },
        { name: "Angular", icon: <FaAngular />, color: "var(--accent-tertiary)" },
        { name: "TypeScript", icon: <SiTypescript />, color: "var(--accent-primary)" },
        { name: "JavaScript", icon: <SiJavascript />, color: "var(--accent-secondary)" },
        { name: "HTML5", icon: <FaHtml5 />, color: "var(--accent-tertiary)" },
        { name: "CSS3", icon: <FaCss3 />, color: "var(--accent-primary)" },
        { name: "Tailwind CSS", icon: <SiTailwindcss />, color: "var(--accent-secondary)" },
        { name: "Cisco Packet Tracer", icon: <FaNetworkWired />, color: "var(--accent-secondary)" },
        { name: "OSPF / RIP / VLANs", icon: <FaSitemap />, color: "var(--accent-primary)" },
        { name: "Figma", icon: <FaFigma />, color: "var(--accent-tertiary)" },
        { name: "UI State Management", icon: <FaLayerGroup />, color: "var(--accent-primary)" },
        { name: "Responsive Design", icon: <FaMobileAlt />, color: "var(--accent-secondary)" }
      ]
    },
    {
      title: "Backend & Systems",
      skills: [
        { name: "Node.js", icon: <FaNodeJs />, color: "var(--accent-secondary)" },
        { name: "Express.js", icon: <SiExpress />, color: "var(--text-primary)" },
        { name: "Spring Boot", icon: <FaJava />, color: "var(--accent-primary)" },
        { name: "MongoDB", icon: <SiMongodb />, color: "var(--accent-secondary)" },
        { name: "PostgreSQL", icon: <SiPostgresql />, color: "var(--accent-primary)" },
        { name: "MySQL", icon: <FaDatabase />, color: "var(--accent-primary)" },
        { name: "Java", icon: <FaJava />, color: "var(--accent-primary)" },
        { name: "C++", icon: <SiCplusplus />, color: "var(--accent-primary)" },
        { name: "MQTT", icon: <FaBroadcastTower />, color: "var(--accent-tertiary)" },
        { name: "Python", icon: <FaPython />, color: "var(--accent-primary)" },
        { name: "RESTful APIs", icon: <FaServer />, color: "var(--accent-tertiary)" },
        { name: "JWT Authentication", icon: <FaKey />, color: "var(--accent-secondary)" },
        { name: "Microservices Architecture", icon: <FaCubes />, color: "var(--accent-primary)" }
      ]
    },
    {
      title: "Data, AI & Computer Vision",
      skills: [
        { name: "Firebase", icon: <SiFirebase />, color: "var(--accent-secondary)" },
        { name: "TensorFlow", icon: <SiTensorflow />, color: "var(--accent-tertiary)" },
        { name: "PyTorch", icon: <SiPytorch />, color: "var(--accent-tertiary)" },
        { name: "OpenCV", icon: <SiOpencv />, color: "var(--accent-primary)" },
        { name: "YOLOv8", icon: <FaEye />, color: "var(--accent-primary)" },
        { name: "Raspberry Pi", icon: <FaMicrochip />, color: "var(--accent-primary)" },
        { name: "ByteTrack", icon: <FaRoute />, color: "var(--accent-secondary)" },
        { name: "MiDaS (Depth Estimation)", icon: <FaMountain />, color: "var(--accent-tertiary)" },
        { name: "MediaPipe / Dlib", icon: <FaUserCircle />, color: "var(--accent-primary)" },
        { name: "NLP", icon: <FaBrain />, color: "var(--accent-primary)" },
        { name: "Real Time Video Processing", icon: <FaVideo />, color: "var(--accent-secondary)" }
      ]
    },
    {
      title: "DevOps, Cloud & Deployment",
      skills: [
        { name: "Docker", icon: <SiDocker />, color: "var(--accent-primary)" },
        { name: "Kubernetes", icon: <SiKubernetes />, color: "var(--accent-primary)" },
        { name: "Git", icon: <FaGitAlt />, color: "var(--accent-tertiary)" },
        { name: "GitHub Actions", icon: <FaGithub />, color: "var(--accent-secondary)" },
        { name: "CI/CD Pipelines", icon: <FaCodeBranch />, color: "var(--accent-primary)" },
        { name: "Linux (Ubuntu)", icon: <FaLinux />, color: "var(--accent-primary)" },
        { name: "Socket Programming", icon: <FaPlug />, color: "var(--accent-secondary)" },
        { name: "AWS", icon: <FaAws />, color: "var(--accent-secondary)" },
        { name: "n8n", icon: <SiN8N />, color: "var(--accent-primary)" },
        { name: "Jenkins", icon: <SiJenkins />, color: "var(--accent-tertiary)" },
        { name: "Minikube", icon: <FaBox />, color: "var(--accent-primary)" }
      ]
    }
  ];

  // Education history, chronological left to right: Merryland first, UoB
  // last since it's the current one. isCurrent drives the pulsing glow and
  // the "Current" badge; everything else is treated as completed.
  const education = [
    {
      institution: "Merryland International School",
      degree: "A Levels, Cambridge",
      period: "September 2020 to June 2022",
      isCurrent: false
    },
    {
      institution: "FAST National University of Computer and Emerging Sciences",
      degree: "BSc Software Engineering",
      period: "August 2022 to June 2026",
      isCurrent: false
    },
    {
      institution: "University of Birmingham",
      degree: "MSc Artificial Intelligence and Machine Learning",
      period: "September 2026 to Present",
      isCurrent: true
    }
  ];

  // Default skills data if not provided
  const defaultSkills = [
    { name: "React", icon: <FaReact />, color: "var(--accent-primary)", level: 90 },
    { name: "Node.js", icon: <FaNodeJs />, color: "var(--accent-secondary)", level: 85 },
    { name: "TypeScript", icon: <SiTypescript />, color: "var(--accent-primary)", level: 80 },
    { name: "Python", icon: <FaPython />, color: "var(--accent-primary)", level: 75 },
    { name: "Next.js", icon: <SiNextdotjs />, color: "var(--text-primary)", level: 85 },
    { name: "MongoDB", icon: <SiMongodb />, color: "var(--accent-secondary)", level: 80 }
  ];

  const skillsData = skills || defaultSkills;

  // The education timeline's connecting line needs to run in a different
  // direction depending on layout: horizontal across a row on desktop,
  // vertical down a stacked column on mobile. Cards already stack on their
  // own via the grid's minmax rule, this just tells the line which way to
  // draw itself so it still visually connects them either way.
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < 768
  );
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const completedCount = education.length - education.filter(e => e.isCurrent).length;
  const progressFraction = completedCount / (education.length - 1);

  return (
    <div
      id="about"
      ref={aboutRef}
      style={{
        minHeight: '100vh',
        background: 'var(--section-bg-1)',
        padding: '6rem 0 0 0',
        position: 'relative',
        overflow: 'hidden',
        scrollMarginTop: '80px'
      }}
    >
      {/* Animated Background Particles */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        zIndex: 1
      }}>
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            style={{
              position: 'absolute',
              width: `${Math.random() * 4 + 2}px`,
              height: `${Math.random() * 4 + 2}px`,
              background: 'var(--accent-primary)',
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              opacity: [0.3, 1, 0.3],
              scale: [1, 1.2, 1]
            }}
            transition={{
              duration: Math.random() * 3 + 2,
              repeat: Infinity,
              delay: Math.random() * 2
            }}
          />
        ))}
      </div>

      <section style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '0 2rem'
        }}>
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '4rem'
            }}
          >
            <motion.h2
              style={{
                fontSize: 'clamp(1.8rem, 5vw, 3.5rem)',
                fontWeight: 'bold',
                background: 'var(--button-primary-bg)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '1rem',
                position: 'relative'
              }}
              initial={{ scale: 0.5 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.8, type: "spring", bounce: 0.4 }}
            >
              <span style={{ color: 'var(--accent-primary)', fontSize: '2rem', marginRight: '1rem' }}>01.</span>
              About Me
              <motion.div
                style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: '50%',
                  width: '100px',
                  height: '4px',
                  background: 'var(--nav-indicator-bg)',
                  borderRadius: '2px'
                }}
                initial={{ scaleX: 0, x: '-50%' }}
                animate={{ scaleX: 1, x: '-50%' }}
                transition={{ duration: 1, delay: 0.5 }}
              />
            </motion.h2>
            <motion.p
              style={{
                fontSize: '1.2rem',
                color: 'var(--text-secondary)',
                maxWidth: '600px',
                margin: '0 auto'
              }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              Crafting digital experiences through innovative technology
            </motion.p>
          </motion.div>

          {/* Main Content Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 420px), 1fr))',
            gap: '2rem',
            alignItems: 'start',
            marginBottom: '4rem'
          }}>
            {/* Left Column: Coding Animation + About Text */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8 }}
              style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}
            >
              {/* Coding Animation */}
              <motion.div
                style={{
                  background: 'var(--card-bg)',
                  borderRadius: '20px',
                  padding: '2rem',
                  border: '1px solid var(--card-border)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '300px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                whileHover={{
                  scale: 1.02,
                  boxShadow: "0 20px 40px var(--card-border)",
                }}
                transition={{ duration: 0.2 }}
              >
                {/* Floating Code Elements */}
                <div style={{ position: 'relative', width: '100%', height: '250px' }}>
                  {/* Background Grid */}
                  <motion.div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundImage: 'linear-gradient(var(--tag-border) 1px, transparent 1px), linear-gradient(90deg, var(--tag-border) 1px, transparent 1px)',
                      backgroundSize: '20px 20px',
                    }}
                    animate={{
                      backgroundPosition: ['0% 0%', '100% 100%']
                    }}
                    transition={{
                      duration: 20,
                      repeat: Infinity,
                      ease: 'linear'
                    }}
                  />

                  {/* Central Workspace */}
                  <motion.div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      width: '150px',
                      height: '100px',
                      background: 'var(--bg-secondary)',
                      borderRadius: '10px',
                      border: '2px solid var(--accent-primary)',
                      transform: 'translate(-50%, -50%)',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '12px',
                      justifyContent: 'space-around',
                      backdropFilter: 'blur(4px)',
                      boxShadow: '0 0 15px var(--tag-border)',
                      zIndex: 2
                    }}
                    initial={{ scale: 0, rotate: -10 }}
                    animate={{
                      scale: 1,
                      rotate: 0,
                      boxShadow: ['0 0 15px var(--tag-border)', '0 0 25px var(--tag-border)', '0 0 15px var(--tag-border)']
                    }}
                    transition={{
                      delay: 0.5,
                      duration: 0.6,
                      type: "spring",
                      boxShadow: {
                        duration: 3,
                        repeat: Infinity
                      }
                    }}
                  >
                    {/* Code Lines */}
                    {[...Array(5)].map((_, i) => (
                      <motion.div
                        key={i}
                        style={{
                          width: `${70 + Math.random() * 25}%`,
                          height: '4px',
                          background: i % 3 === 0 ? 'var(--accent-primary)' : i % 3 === 1 ? 'var(--accent-secondary)' : 'var(--accent-tertiary)',
                          borderRadius: '2px',
                        }}
                        initial={{ width: 0 }}
                        animate={{
                          width: `${70 + Math.random() * 25}%`,
                          opacity: [0.8, 1, 0.8]
                        }}
                        transition={{
                          delay: 0.8 + i * 0.15,
                          duration: 0.8,
                          opacity: {
                            duration: 2,
                            repeat: Infinity
                          }
                        }}
                      />
                    ))}
                  </motion.div>

                  {[
                    { icon: <FaReact />, color: 'var(--accent-primary)', pos: { top: '25%', left: '5%' }, size: '2.2rem' },
                    { icon: <FaNodeJs />, color: 'var(--accent-secondary)', pos: { top: '10%', right: '35%' }, size: '2.2rem' },
                    { icon: <SiTypescript />, color: 'var(--accent-primary)', pos: { bottom: '2%', left: '15%' }, size: '2rem' },
                    { icon: <FaPython />, color: 'var(--accent-primary)', pos: { bottom: '25%', right: '10%' }, size: '2rem' },
                    { icon: <FaDatabase />, color: 'var(--accent-tertiary)', pos: { top: '10%', left: '30%' }, size: '1.8rem' },
                    { icon: <FaGitAlt />, color: 'var(--accent-tertiary)', pos: { bottom: '25%', right: '58%' }, size: '1.8rem' }
                  ].map((tech, i) => (
                    <motion.div
                      key={i}
                      style={{
                        position: 'absolute',
                        ...tech.pos,
                        fontSize: tech.size,
                        color: tech.color,
                        opacity: 0.7,
                        zIndex: 1
                      }}
                      animate={{
                        y: [0, -15, 0],
                        rotate: [0, 5, -5, 0],
                        opacity: [0.7, 1, 0.7],
                        scale: [1, 1.1, 1]
                      }}
                      transition={{
                        duration: 4 + i * 0.5,
                        repeat: Infinity,
                        delay: i * 0.3,
                        ease: 'easeInOut'
                      }}
                    >
                      {tech.icon}
                    </motion.div>
                  ))}

                  {/* Cursor */}
                  <motion.div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '60%',
                      width: '2px',
                      height: '16px',
                      background: 'var(--accent-primary)',
                      zIndex: 3
                    }}
                    animate={{
                      opacity: [0, 1, 0],
                      y: [-10, 10, -10]
                    }}
                    transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      ease: 'easeInOut'
                    }}
                  />

                  {/* Terminal Text */}
                  <motion.div
                    style={{
                      position: 'absolute',
                      top: '15px',
                      left: '10px',
                      color: 'var(--accent-primary)',
                      fontSize: '0.9rem',
                      fontFamily: 'monospace',
                      opacity: 0.8,
                      zIndex: 3
                    }}
                    animate={{
                      opacity: [0.8, 1, 0.8],
                      textShadow: ['0 0 5px var(--tag-border)', '0 0 10px var(--tag-border)', '0 0 5px var(--tag-border)']
                    }}
                    transition={{
                      duration: 2,
                      repeat: Infinity
                    }}
                  >
                    $ npm run dev
                  </motion.div>

                  {/* Animated Connection Lines — static coords to prevent re-render jank */}
                  <svg width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0, zIndex: 0 }}>
                    {[
                      { x1: 10, y1: 20, x2: 50, y2: 60 },
                      { x1: 80, y1: 15, x2: 40, y2: 75 },
                      { x1: 25, y1: 80, x2: 70, y2: 30 },
                      { x1: 60, y1: 90, x2: 90, y2: 45 },
                      { x1: 5, y1: 55, x2: 55, y2: 10 },
                      { x1: 75, y1: 65, x2: 20, y2: 95 },
                    ].map((l, i) => (
                      <motion.line
                        key={i}
                        x1={`${l.x1}%`} y1={`${l.y1}%`}
                        x2={`${l.x2}%`} y2={`${l.y2}%`}
                        stroke="var(--tag-border)"
                        strokeWidth="1"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: [0, 0.25, 0] }}
                        transition={{ duration: 6 + i * 2, repeat: Infinity, delay: i * 0.6 }}
                      />
                    ))}
                  </svg>

                  {/* Floating Code Particles - reduced for performance */}
                  {[...Array(6)].map((_, i) => (
                    <motion.div
                      key={i}
                      style={{
                        position: 'absolute',
                        top: `${[15, 30, 55, 70, 20, 80][i]}%`,
                        left: `${[10, 75, 20, 85, 50, 40][i]}%`,
                        color: ['var(--accent-primary)', 'var(--accent-secondary)', 'var(--accent-tertiary)', 'var(--text-primary)', 'var(--text-secondary)', 'var(--accent-primary)'][i],
                        fontSize: '0.75rem',
                        fontFamily: 'monospace',
                        opacity: 0,
                        zIndex: 1
                      }}
                      animate={{
                        y: [0, -40],
                        opacity: [0, 0.7, 0],
                      }}
                      transition={{
                        duration: 8 + i * 2,
                        repeat: Infinity,
                        delay: i * 0.8,
                        ease: 'linear'
                      }}
                    >
                      {['const', 'function', '=>', 'import', '{}', 'return'][i]}
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* About Text */}
              <motion.div
                style={{
                  background: 'var(--card-bg)',
                  borderRadius: '20px',
                  padding: '2rem',
                  border: '1px solid var(--card-border)'
                }}
                whileHover={{ scale: 1.02, boxShadow: "0 20px 40px var(--card-border)" }}
                transition={{ duration: 0.2, delay: 0.1 }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                <h3 style={{
                  color: 'var(--accent-primary)',
                  fontSize: '1.5rem',
                  marginBottom: '1rem',
                  fontWeight: 'bold'
                }}>
                  The Journey
                </h3>
                <p style={{
                  color: 'var(--text-primary)',
                  lineHeight: '1.8',
                  marginBottom: '1rem',
                  fontSize: '1rem'
                }}>
                  My path into tech started at Merryland International School in Abu Dhabi, then
                  continued through a Software Engineering degree at FAST NUCES in Islamabad. Right
                  now I'm building on that with a Masters in Artificial Intelligence and Machine
                  Learning from the University of Birmingham, going deeper into the field while still shipping real projects on the
                  side.
                </p>
                <p style={{
                  color: 'var(--text-primary)',
                  lineHeight: '1.8',
                  marginBottom: '1rem',
                  fontSize: '1rem'
                }}>
                  Over the past 2 plus years I've built hands on experience in full stack web
                  development, REST APIs, and UI/UX design. I enjoy building meaningful tech
                  solutions, from interactive web apps to IoT systems, that solve real world
                  problems.
                </p>
                <p style={{
                  color: 'var(--text-primary)',
                  lineHeight: '1.8',
                  fontSize: '1rem'
                }}>
                  My passion lies in transforming complex problems into elegant solutions, whether
                  it's building and training life changing AI models, designing intuitive user
                  experiences, or engineering scalable platforms.
                </p>
              </motion.div>
            </motion.div>

            {/* Right Column: Skills */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <motion.div
                style={{
                  background: 'var(--card-bg)',
                  borderRadius: '20px',
                  padding: '2rem',
                  border: '1px solid var(--card-border)',
                  height: '100%'
                }}
                whileHover={{ scale: 1.02, boxShadow: "0 20px 40px var(--card-border)" }}
                transition={{ duration: 0.2 }}
              >
                <h3 style={{
                  color: 'var(--accent-primary)',
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  marginBottom: '2rem',
                  textAlign: 'center'
                }}>
                  Technical Mastery
                </h3>

                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: '1.5rem'
                }}>
                  {skillsData.map((skill, index) => (
                    <motion.div
                      key={index}
                      style={{
                        background: 'var(--tag-bg)',
                        borderRadius: '15px',
                        padding: '1.5rem',
                        border: '1px solid var(--tag-border)',
                        textAlign: 'center'
                      }}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.6, delay: index * 0.1 }}
                      whileHover={{
                        y: -5,
                        scale: 1.05,
                        boxShadow: `0 15px 30px ${skill.color}40`,
                        background: 'var(--card-bg)'
                      }}
                    >
                      <motion.div
                        style={{
                          fontSize: '2.5rem',
                          color: skill.color,
                          marginBottom: '1rem'
                        }}
                        animate={{
                          rotate: [0, 5, -5, 0],
                          scale: [1, 1.1, 1]
                        }}
                        transition={{
                          duration: 2,
                          repeat: Infinity,
                          delay: index * 0.3
                        }}
                      >
                        {skill.icon}
                      </motion.div>
                      <h4 style={{
                        color: 'var(--text-primary)',
                        fontSize: '1.1rem',
                        fontWeight: 'bold',
                        marginBottom: '1rem'
                      }}>
                        {skill.name}
                      </h4>
                      <div style={{
                        background: 'var(--tag-bg)',
                        borderRadius: '10px',
                        height: '8px',
                        overflow: 'hidden',
                        marginBottom: '0.5rem'
                      }}>
                        <motion.div
                          style={{
                            height: '100%',
                            background: skill.color,
                            borderRadius: '10px'
                          }}
                          initial={{ width: 0 }}
                          whileInView={{ width: `${skill.level}%` }}
                          viewport={{ once: true }}
                          transition={{ duration: 1.5, delay: 0.5 + index * 0.1 }}
                        />
                      </div>
                      <span style={{
                        color: skill.color,
                        fontSize: '0.9rem',
                        fontWeight: 'bold'
                      }}>
                        {skill.level}%
                      </span>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Education */}
          <motion.div
            style={{
              background: 'var(--card-bg)',
              borderRadius: '20px',
              padding: '3rem',
              border: '1px solid var(--card-border)',
              marginBottom: '4rem',
              position: 'relative',
              overflow: 'hidden'
            }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            whileHover={{ boxShadow: "0 25px 50px var(--card-border)" }}
          >
            {[...Array(6)].map((_, i) => (
              <motion.div
                key={i}
                style={{
                  position: 'absolute',
                  width: '3px',
                  height: '3px',
                  borderRadius: '50%',
                  background: 'var(--accent-primary)',
                  top: `${[10, 25, 60, 80, 40, 15][i]}%`,
                  left: `${[5, 90, 12, 85, 50, 70][i]}%`,
                  opacity: 0.4
                }}
                animate={{ opacity: [0.2, 0.6, 0.2], scale: [1, 1.6, 1] }}
                transition={{ duration: 4 + i, repeat: Infinity, delay: i * 0.5 }}
              />
            ))}

            <div style={{ textAlign: 'center', marginBottom: '3rem', position: 'relative', zIndex: 1 }}>
              <h3 style={{
                color: 'var(--accent-primary)',
                fontSize: '2rem',
                fontWeight: 'bold',
                marginBottom: '0.5rem'
              }}>
                Education
              </h3>
              <p style={{
                color: 'var(--text-secondary)',
                fontSize: '1rem'
              }}>
                Building the foundation for what comes next
              </p>
            </div>

            <div style={{ position: 'relative' }}>
              {/* Track: the full path, drawn in on scroll, dim. Runs
                  horizontally across the row on desktop, or vertically down
                  the column once the cards stack on mobile, so the line
                  always actually connects the cards rather than only ever
                  drawing itself sideways. */}
              {isMobile ? (
                <motion.div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '18px',
                    bottom: '18px',
                    width: '2px',
                    background: 'var(--tag-border)',
                    transform: 'translateX(-50%)',
                    transformOrigin: 'top',
                    borderRadius: '2px',
                    zIndex: 0
                  }}
                  initial={{ scaleY: 0 }}
                  whileInView={{ scaleY: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: 'easeInOut' }}
                />
              ) : (
                <motion.div
                  style={{
                    position: 'absolute',
                    top: '17px',
                    left: '8%',
                    right: '8%',
                    height: '2px',
                    background: 'var(--tag-border)',
                    transformOrigin: 'left',
                    borderRadius: '2px',
                    zIndex: 0
                  }}
                  initial={{ scaleX: 0 }}
                  whileInView={{ scaleX: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: 'easeInOut' }}
                />
              )}

              {/* Fill: how far along the journey actually is, completed
                  entries out of the total. Sits on top of the dim track so
                  the finished stretch reads clearly against what is still
                  in progress. Same data drives both orientations. */}
              {isMobile ? (
                <motion.div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '18px',
                    width: '2px',
                    background: 'linear-gradient(180deg, var(--accent-primary), var(--accent-tertiary))',
                    transform: 'translateX(-50%)',
                    borderRadius: '2px',
                    zIndex: 0
                  }}
                  initial={{ height: 0 }}
                  whileInView={{ height: `calc(${progressFraction * 100}% - ${progressFraction * 36}px)` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, delay: 0.3, ease: 'easeInOut' }}
                />
              ) : (
                <motion.div
                  style={{
                    position: 'absolute',
                    top: '17px',
                    left: '8%',
                    height: '2px',
                    background: 'linear-gradient(90deg, var(--accent-primary), var(--accent-tertiary))',
                    borderRadius: '2px',
                    zIndex: 0
                  }}
                  initial={{ width: 0 }}
                  whileInView={{ width: `${progressFraction * 84}%` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, delay: 0.3, ease: 'easeInOut' }}
                />
              )}

              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))',
                gap: isMobile ? '2.5rem' : '1.5rem',
                position: 'relative',
                zIndex: 1
              }}>
                {education.map((edu, index) => (
                  <motion.div
                    key={index}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.15 }}
                  >
                    <motion.div
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        background: edu.isCurrent ? 'var(--accent-primary)' : 'var(--accent-tertiary)',
                        border: `2px solid ${edu.isCurrent ? 'var(--accent-primary)' : 'var(--accent-tertiary)'}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '1rem'
                      }}
                      animate={edu.isCurrent ? {
                        boxShadow: [
                          '0 0 0px var(--accent-primary)',
                          '0 0 18px var(--accent-primary)',
                          '0 0 0px var(--accent-primary)'
                        ]
                      } : {}}
                      transition={{ duration: 2.2, repeat: Infinity }}
                      whileHover={{ rotate: [0, -8, 8, 0], scale: 1.1 }}
                    >
                      {edu.isCurrent ? (
                        <FaGraduationCap style={{ fontSize: '1rem', color: '#fff' }} />
                      ) : (
                        <FaCheck style={{ fontSize: '0.85rem', color: '#fff' }} />
                      )}
                    </motion.div>

                    <motion.div
                      style={{
                        background: 'var(--tag-bg)',
                        border: `1px solid ${edu.isCurrent ? 'var(--accent-primary)' : 'var(--tag-border)'}`,
                        borderRadius: '14px',
                        padding: '1.2rem 1.3rem',
                        width: '100%'
                      }}
                      whileHover={{
                        y: -6,
                        rotate: index % 2 === 0 ? -1 : 1,
                        boxShadow: '0 15px 30px var(--tag-border)',
                        background: 'var(--card-bg)'
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        gap: '0.5rem',
                        marginBottom: '0.4rem'
                      }}>
                        <h4 style={{
                          color: 'var(--text-primary)',
                          fontSize: '1rem',
                          fontWeight: 'bold',
                          margin: 0
                        }}>
                          {edu.institution}
                        </h4>
                        {edu.isCurrent && (
                          <span style={{
                            position: 'relative',
                            overflow: 'hidden',
                            fontSize: '0.65rem',
                            fontWeight: 'bold',
                            color: '#fff',
                            background: 'var(--accent-primary)',
                            borderRadius: '999px',
                            padding: '0.15rem 0.55rem',
                            letterSpacing: '0.03em',
                            display: 'inline-block'
                          }}>
                            Current
                            <motion.span
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: '-60%',
                                width: '50%',
                                height: '100%',
                                background: 'linear-gradient(120deg, transparent, rgba(255,255,255,0.7), transparent)'
                              }}
                              animate={{ left: ['-60%', '130%'] }}
                              transition={{ duration: 2.2, repeat: Infinity, repeatDelay: 1.2 }}
                            />
                          </span>
                        )}
                      </div>
                      <p style={{
                        color: 'var(--accent-primary)',
                        fontSize: '0.9rem',
                        fontWeight: '500',
                        margin: '0 0 0.3rem 0'
                      }}>
                        {edu.degree}
                      </p>
                      <p style={{
                        color: 'var(--text-secondary)',
                        fontSize: '0.8rem',
                        margin: 0
                      }}>
                        {edu.period}
                      </p>
                    </motion.div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Stats Section */}
          <motion.div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '2rem',
              marginBottom: '4rem'
            }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {[
              { number: "20+", label: "Projects Delivered" },
              { number: "2+", label: "Years Experience" },
              { number: "95%", label: "Client Satisfaction" },
              { number: "24/7", label: "Available for Code" }
            ].map((stat, index) => (
              <motion.div
                key={index}
                style={{
                  background: 'var(--button-primary-bg)',
                  borderRadius: '20px',
                  padding: '2rem',
                  textAlign: 'center',
                  border: '1px solid var(--card-border)'
                }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 20px 40px var(--card-border)",
                  y: -10
                }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <motion.div
                  style={{
                    fontSize: '2.5rem',
                    fontWeight: 'bold',
                    color: 'var(--text-primary)',
                    marginBottom: '0.5rem'
                  }}
                  animate={{
                    scale: [1, 1.1, 1],
                    textShadow: [
                      "0 0 0 var(--text-primary)",
                      "0 0 20px var(--text-secondary)",
                      "0 0 0 var(--text-primary)"
                    ]
                  }}
                  transition={{
                    duration: 3,
                    repeat: Infinity,
                    delay: index * 0.5
                  }}
                >
                  {stat.number}
                </motion.div>
                <div style={{
                  color: 'var(--text-primary)',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Technology Stack */}
          <motion.div
            style={{
              background: 'var(--card-bg)',
              borderRadius: '20px',
              padding: '3rem 3rem 2rem 3rem',
              border: '1px solid var(--card-border)',
              marginBottom: '0'
            }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            whileHover={{ boxShadow: "0 25px 50px var(--card-border)" }}
          >
            <h3 style={{
              color: 'var(--accent-primary)',
              fontSize: '2rem',
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: '3rem'
            }}>
              Technology Stack
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))',
              gap: '2rem'
            }}>
              {skillCategories.map((category, catIndex) => (
                <motion.div
                  key={catIndex}
                  style={{
                    background: 'var(--tag-bg)',
                    borderRadius: '15px',
                    padding: '2rem',
                    border: '1px solid var(--tag-border)'
                  }}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: catIndex * 0.1 }}
                  whileHover={{
                    scale: 1.03,
                    boxShadow: "0 15px 30px var(--tag-border)",
                    background: 'var(--card-bg)'
                  }}
                >
                  <h4 style={{
                    color: 'var(--text-primary)',
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '1.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <span style={{ color: category.skills[0].color, fontSize: '1.5rem' }}>
                      {category.skills[0].icon}
                    </span>
                    {category.title}
                  </h4>
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.8rem'
                  }}>
                    {category.skills.map((skill, skillIndex) => (
                      <motion.div
                        key={skillIndex}
                        style={{
                          background: 'var(--tag-bg)',
                          border: '1px solid var(--tag-border)',
                          borderRadius: '25px',
                          padding: '0.5rem 1rem',
                          color: skill.color,
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}
                        whileHover={{
                          scale: 1.05,
                          boxShadow: `0 8px 16px var(--tag-border)`,
                          background: 'var(--card-bg)'
                        }}
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: skillIndex * 0.1, duration: 0.5 }}
                      >
                        <span style={{ fontSize: '1rem' }}>
                          {skill.icon}
                        </span>
                        {skill.name}
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;